// Diretiva simples para máscaras de input
export default {
  bind(el, binding) {
    const mask = binding.value
    
    const applyMask = (e) => {
      let value = e.target.value.replace(/\D/g, '')
      let maskedValue = ''
      let valueIndex = 0
      
      for (let i = 0; i < mask.length && valueIndex < value.length; i++) {
        if (mask[i] === '#') {
          maskedValue += value[valueIndex]
          valueIndex++
        } else {
          maskedValue += mask[i]
        }
      }
      
      if (e.target.value !== maskedValue) {
        e.target.value = maskedValue
        // Disparar evento input para atualizar v-model
        e.target.dispatchEvent(new Event('input', { bubbles: true }))
      }
    }
    
    el.addEventListener('input', applyMask)
    el.addEventListener('paste', (e) => {
      setTimeout(() => applyMask(e), 0)
    })
  }
}

